window.loadedScripts = 1;
import polyfills from '@core/polyfills';
//import swiper from './slider';
import hamburger from './hamburger';
import headroom from './headroom';
import scrollIt from './scrollToAnchor';
import cookieconsent from 'cookieconsent';
import overlay from './overlay';
import lazyLoad from './lazyLoad';
import hero from './hero'
import { Video } from '@core/video';
// import scrollReveal from './reveal';   disabled for now need to be improved

new Video([...document.querySelectorAll('[data-video]')]);

// toggle lang navigation
let langEl = document.querySelector('.languages');
if ( langEl ) {
    langEl.addEventListener('click', (e) =>{
      e.target.parentElement.classList.toggle('active');
    });
}

// Scroll to
const btns = document.querySelectorAll('a[href*="#"]:not([href="#"])');
if ( btns ) {
    btns.forEach( (el) => {
        el.addEventListener('click', () => {
            if (el.getAttribute('data-toggle')) {
                return ;
            }
            console.log('Clicked');
            let hrefEl = el.getAttribute('href');
            let idEl = document.querySelector(`${hrefEl}`);
            scrollIt(idEl, 800, 'easeOutCubic');
        });
    });
}


// WEBPACK FOOTER //
// ./themes/default/assets/js/main.js